export const ASSETS = {
    background:
        'https://customer-assets-jt897jd0.emergentagent.net/job_journal-flip-app/artifacts/rxbx1g80_ChatGPT%20Image%20Jul%2024%2C%202026%2C%2003_37_30%20PM.png',
    cover:
        'https://customer-assets-jt897jd0.emergentagent.net/job_journal-flip-app/artifacts/lcy4lzt4_front%20cover%20modiffied%20version.jpg',
    chime:
        'https://customer-assets-jt897jd0.emergentagent.net/job_journal-flip-app/artifacts/xikiwgso_sudio%20for%20sign%20up%20complete.wav',
    logo:
        'https://customer-assets-jt897jd0.emergentagent.net/job_journal-flip-app/artifacts/mr8l0zow_studyfolio%20dpi%20500%20%20png.png',
};
